import { createSelector } from 'reselect'
import { NAME } from './constants'

export const getSelectedDashboard = createSelector(
  (state) => state[NAME].dashboardId,
  (dashboardId) => dashboardId
)

export default { getSelectedDashboard }
